import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-trouwen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconTrouwen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M18.28 30.57c.61.34 1.25.64 1.91.88C18.07 34.3 14.78 36 11.22 36 5.04 36 .01 30.97.01 24.79s5.03-11.21 11.21-11.21 11.21 5.03 11.21 11.21c0 .32-.02.66-.06 1.01-.73-.25-1.4-.62-2.01-1.09-.04-5.01-4.13-9.06-9.15-9.06s-9.15 4.1-9.15 9.14 4.1 9.15 9.15 9.15c2.75 0 5.33-1.25 7.07-3.37m17.65-10.16c-.6 5.43-5.24 9.72-10.71 9.92-6.38.24-11.65-4.87-11.65-11.2 0-.35.03-.71.07-1.08.72.25 1.39.62 2 1.08 0 3.76 2.24 7.26 5.77 8.54 6.39 2.32 12.4-2.31 12.52-8.35.06-2.86-1.42-5.48-3.65-7.28-2.48-2.01-5.06-2.35-7.4-1.84-.25.05-.49.12-.74.18-.67.16-1.28.47-1.86.82-.1.06-.21.12-.31.18-.82.52-1.57 1.16-2.2 1.92-.61-.35-1.25-.65-1.92-.9 1.02-1.35 2.35-2.46 3.86-3.23v-.03a10.9 10.9 0 0 1 1.77-.71l-2.16-3.86c-.19-.35-.17-.77.07-1.09l2.33-3.1a1 1 0 0 1 .8-.4h4.95c.31 0 .61.15.8.4l2.34 3.1a1 1 0 0 1 .07 1.1l-2.26 3.94c.68.23 1.34.51 1.96.86v.04c3.79 2.17 6.07 6.39 5.56 10.99ZM23.52 7.98c.43-.05.86-.08 1.3-.08.53 0 1.06.04 1.57.12l2.24-4-1.74-2.03h-3.81l-1.72 2.03 2.16 3.97Z"/>
</svg>

    );
  }
}
